<div class="modal-body">
    <button type="button" type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span aria-hidden="true">&times;</span>
    </button>
    <div class="m-auto img-wrapper text-center">
        <img [src]="imgSrc" />
    </div>
</div>
